import { render } from "./ScoutView.vue?vue&type=template&id=5525272e&scoped=true"
import script from "./ScoutView.vue?vue&type=script&lang=js"
export * from "./ScoutView.vue?vue&type=script&lang=js"

import "./ScoutView.vue?vue&type=style&index=0&id=5525272e&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5525272e"]])

export default __exports__